// Browser identifier configuration
export const TIKTOK_KEYS = {
  localStorage: ["HYBRID_SLARDAR_WEBtiktok_pns_webview"],
  userAgent: ["BytedanceWebview", "musical_ly"],
};

export function isTiktokIAB() {
  if (TIKTOK_KEYS.localStorage.some((key) => localStorage.getItem(key) !== null)) {
    return true;
  }
  if (
    navigator &&
    TIKTOK_KEYS.userAgent.some((item) => navigator.userAgent.toLowerCase().includes(item.toLowerCase()))
  ) {
    return true;
  }
  return false;
}

// If you need to add more check here for reference https://github.com/matomo-org/device-detector/blob/a29d2408164f5023a8825c563e75931280b84d8a/regexes/client/mobile_apps.yml#L104
// Should be noted currently these primarily serve as fallbacks if no referrer is set in the IAB, currently it appears tiktok is the only one that does that.
const iabRegex = [
  // facebook
  /(?:FBAV|com\.facebook\.katana|facebook-mobile\/1\.0|facebook-mobile\/|Facebook\/)(?:[ /]([\d.]+))?/,
  /(?:FBAN|FBSV|FBID|FBBV)\//,
  /(?:MessengerForiOS|MESSENGER|FB_IAB\/Orca-Android).*(?:FBAV)(?:[ /]([\d.]+))?/,
  // instagram
  /Instagram(?:[ /])([\d.]+)?/,
  // pintrest
  /Pinterest(?: for (?:Android(?: Tablet)?|iOS))?(?:\/([\d.]+))?/,
  // google
  /(?:com\.google\.GoogleMobile|GSA|GoogleApp)\/([\d.]+)?/,
  /Google\/(\d+[.\d]+)? CFNetwork/,
];

export function isIab() {
  // prevents running on SSR
  if (typeof window !== "undefined") {
    return isTiktokIAB() || iabRegex.some((regex) => regex.test(navigator?.userAgent));
  }
}
